var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateExisting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 116,
    viewBox: "0 0 114 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 113,
    height: 115,
    rx: 9.5,
    fill: "#F8F8F8",
    stroke: "#A9A9A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.6665 34.6667H38.3332C35.7558 34.6667 33.6665 36.7561 33.6665 39.3334V48.6667C33.6665 51.2441 35.7558 53.3334 38.3332 53.3334H75.6665C78.2438 53.3334 80.3332 51.2441 80.3332 48.6667V39.3334C80.3332 36.7561 78.2438 34.6667 75.6665 34.6667Z",
    stroke: "#717171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6665 62.6667H38.3332C35.7558 62.6667 33.6665 64.7561 33.6665 67.3334V76.6668C33.6665 79.2441 35.7558 81.3334 38.3332 81.3334H75.6665C78.2438 81.3334 80.3332 79.2441 80.3332 76.6668V67.3334C80.3332 64.7561 78.2438 62.6667 75.6665 62.6667Z",
    stroke: "#717171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 44H43.0233",
    stroke: "#717171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 72H43.0233",
    stroke: "#717171",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateExisting);
export default __webpack_public_path__ + "static/media/createExisting.b53d87c0ef8d06069b8cb48c75324981.svg";
export { ForwardRef as ReactComponent };